import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Checkbox } from 'wix-style-react';
import BaseFilter from '../BaseFilter/BaseFilter';
import languageFilterUtils from './languageFilterUtils';
import s from './languageFilter.scss';

class LanguageFilter extends Component {
  onSelect(lang) {
    const { currentLanguages, onChange } = this.props;
    const newlySelectedLangs = languageFilterUtils.onToggleLanguage(
      currentLanguages,
      lang,
    );
    onChange({ lang: newlySelectedLangs });
  }

  render() {
    const {
      possibleLanguages,
      filterTitle,
      applyButtonText,
      clearButtonText,
      currentLanguages,
      onApply,
      onChange,
      t,
    } = this.props;

    return (
      <BaseFilter
        filterDataHook="explore-language-filter"
        filterTitle={filterTitle}
        applyButtonText={applyButtonText}
        clearButtonText={clearButtonText}
        applyButtonDataHook="explore-language-filter-apply-button"
        clearButtonDataHook="explore-language-filter-clear-button"
        isClearDisabled={currentLanguages.length === 0}
        onApply={() => onApply({ lang: currentLanguages })}
        onClear={() => onChange({ lang: [] })}
      >
        <div className={s.container}>
          {possibleLanguages.map(lang => (
            <div key={lang} className={s.language}>
              <Checkbox
                dataHook={`option-${lang.key}`}
                checked={currentLanguages.includes(lang.key)}
                onChange={() => this.onSelect(lang.key)}
              >
                {lang.displayName}
              </Checkbox>
            </div>
          ))}
        </div>
      </BaseFilter>
    );
  }
}

export default translate()(LanguageFilter);
